import React, { useEffect, useState } from 'react';
import ProfileBanner from '../ProfileBanner';
// import coverSrc from 'assets/img/generic/4.jpg';
// import avatar from 'assets/img/team/2.jpg';
import { Button, Card, Col, Row } from 'react-bootstrap';
import ProfileSettings from './ProfileSettings';
import ExperiencesSettings from './ExperiencesSettings';
import EducationSettings from './EducationSettings';
// import AccountSettings from './AccountSettings';
// import BillingSettings from './BillingSettings';
// import ChangePassword from './ChangePassword';
// import DangerZone from './DangerZone';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getNurseDetails, updateDetails } from 'nursd-dashboard/api/nurseTable';
import { useNavigate, useParams } from 'react-router-dom';
import {
  optionsEMR,
  optionsSkill,
  optionsSpecialty
} from 'nursd-dashboard/data/defaultData';
import CertificationSettings from './CertificationSettings';
import { toast } from 'react-toastify';
import { removeFormatting } from 'nursd-dashboard/utils/function';

const Settings = () => {
  const { nurseId } = useParams();
  const { authToken } = useAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    clinicalLicenseNumber: '',
    clinicalLicenseExpirationDate: new Date(),
    primaryLicenseType: '',
    poolType: 'Internal Pool'
  });
  const [education, setEducation] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [certification, setCertification] = useState([]);
  const [valueSpecialty, setValueSpecialty] = useState(null);
  const [valueSkill, setValueSkill] = useState(null);
  const [valueEMR, setValueEMR] = useState(null);
  const navigate = useNavigate();

  const checkUser = async (authToken, id) => {
    try {
      await getNurseDetails(authToken, id).then(res => {
        if (res === undefined) {
          setUser(null);
          setLoading(false);
        } else {
          setUser(res);
          // console.log(res);
          setFormData({
            firstName: res?.firstName,
            lastName: res?.lastName,
            email: res?.emailId,
            phone: res?.phoneNumber,
            clinicalLicenseNumber: res?.clinicalLicenseNumber,
            clinicalLicenseExpirationDate: new Date(
              res?.clinicalLicenseExpirationDate
            ),
            primaryLicenseType: res?.primaryLicenseType,
            poolType: res?.poolType
          });
          let EMRorEHRExperience = [];
          if (res?.EMRorEHRExperience?.length !== 0) {
            for (
              let index = 0;
              index < res?.EMRorEHRExperience.length;
              index++
            ) {
              const element = res?.EMRorEHRExperience[index];
              let id = optionsEMR.filter(i => i.label === element)[0];
              let obj = {
                value: id.value,
                label: element
              };
              EMRorEHRExperience.push(obj);
            }
          }
          if (res?.EMRorEHRExperience?.length === EMRorEHRExperience?.length) {
            setValueEMR(EMRorEHRExperience);
          }
          let skills = [];
          if (res?.skills?.length !== 0) {
            for (let index = 0; index < res?.skills.length; index++) {
              const element = res?.skills[index];
              let id = optionsSkill.filter(i => i.label === element)[0];
              let obj = {
                value: id.value,
                label: element
              };
              skills.push(obj);
            }
          }
          if (res?.skills?.length === skills?.length) {
            setValueSkill(skills);
          }
          let specialty = [];
          if (res?.specialty?.length !== 0) {
            for (let index = 0; index < res?.specialty.length; index++) {
              const element = res?.specialty[index];
              let id = optionsSpecialty.filter(i => i.label === element)[0];
              let obj = {
                value: id.value,
                label: element
              };
              specialty.push(obj);
            }
          }
          if (res?.specialty?.length === specialty?.length) {
            setValueSpecialty(specialty);
          }
          setEducation(
            res?.educationDetails?.length !== 0 &&
              res?.educationDetails !== undefined
              ? res?.educationDetails
              : []
          );
          setExperiences(
            res?.workExperienceDetails?.length !== 0 &&
              res?.workExperienceDetails !== undefined
              ? res?.workExperienceDetails
              : []
          );
          setCertification(
            res?.certificationDetails?.length !== 0 &&
              res?.certificationDetails !== undefined
              ? res?.certificationDetails
              : []
          );
          setLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
    }
  }, [nurseId]);

  const update = async () => {
    await updateDetails(authToken, nurseId, {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phoneNumber: removeFormatting(formData.phone),
      clinicalLicenseNumber: formData?.clinicalLicenseNumber,
      clinicalLicenseExpirationDate: new Date(
        formData?.clinicalLicenseExpirationDate
      ),
      primaryLicenseType: formData?.primaryLicenseType,
      poolType: formData?.poolType,
      certificationDetails: certification,
      educationDetails: education,
      specialty: valueSpecialty?.map(i => i.label),
      skills: valueSkill?.map(i => i.label),
      EMRorEHRExperience: valueEMR?.map(i => i.label),
      workExperienceDetails: experiences
    }).then(() => {
      toast.success(
        `${
          formData?.firstName + ' ' + formData?.lastName
        } nurse updated successfully!`,
        {
          theme: 'colored'
        }
      );
      navigate(-1);
    });
  };

  const updateProfileImage = async image => {
    await updateDetails(authToken, nurseId, {
      profileImage: image
    }).then(() => {
      toast.success(
        `${
          formData?.firstName + ' ' + formData?.lastName
        } nurse updated successfully!`,
        {
          theme: 'colored'
        }
      );
      navigate(-1);
    });
  };

  return (
    <>
      {loading ? (
        <Card>
          <p className="mt-2">Loading...</p>
        </Card>
      ) : (
        <>
          <ProfileBanner>
            <ProfileBanner.Header
              coverSrc={''}
              avatar={
                user?.profileImage
                  ? user?.profileImage
                  : user?.firstName + ' ' + user?.lastName
              }
              user={user}
              updateProfileImage={updateProfileImage}
              className="mb-8"
            />
          </ProfileBanner>
          <Row className="g-3">
            <Col lg={12}>
              <ProfileSettings
                formData={formData}
                setFormData={setFormData}
                valueSpecialty={valueSpecialty}
                setValueSpecialty={setValueSpecialty}
                valueSkill={valueSkill}
                setValueSkill={setValueSkill}
                valueEMR={valueEMR}
                setValueEMR={setValueEMR}
              />
              <CertificationSettings
                certification={certification}
                setCertification={setCertification}
              />
              <EducationSettings
                education={education}
                setEducation={setEducation}
              />
              <ExperiencesSettings
                experiences={experiences}
                setExperiences={setExperiences}
              />
              <div className="text-end mt-3">
                <Button
                  variant="secondary"
                  className="mx-2"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                <Button variant="primary" onClick={() => update()}>
                  Update
                </Button>
              </div>
            </Col>
            {/* <Col lg={4}>
              <div className="sticky-sidebar">
                <AccountSettings />
                <BillingSettings />
                <ChangePassword />
                <DangerZone />
              </div>
            </Col> */}
          </Row>
        </>
      )}
    </>
  );
};

export default Settings;
